import { useNavigate } from 'react-router-dom';
import { Field, Forms } from '@ofself/shell';
import { NUCLEUS_URL } from '../services/apiConfig';
import '../styles/Auth.css';

// SIGNING UP HAPPENS IN NUCLEUS (decision 2026-10-07, signup-is-phone-verified):
// one signup and one gate — the human check, the phone — for every ofSelf
// account. The portal hands the person to Nucleus's join, which brings them
// back to sign in here when it is done (its `next`).
export const nucleusSignupUrl = (origin = window.location.origin) => (
  `${NUCLEUS_URL}/register?next=${encodeURIComponent(`${origin}/login`)}`
);

function Register() {
  const navigate = useNavigate();
  const go = (e) => {
    e.preventDefault();
    window.location.assign(nucleusSignupUrl());
  };

  return (
    <Field>
      <Forms
        statement="Create your OfSelf account"
        mark={<img src="/ofself-logo.svg" alt="" />}
        onSubmit={go}
      >
        <Forms.Block>
          <Forms.Note className="auth-help">
            Your ofSelf account is created in Nucleus, where you also verify your phone. The same
            account then signs you in here.
          </Forms.Note>
        </Forms.Block>

        <Forms.Cta>Continue to Nucleus</Forms.Cta>

        <Forms.Foot>
          <Forms.FootCell href="/login" onNavigate={navigate}>
            <span>Already have an account? <strong>Sign in↗</strong></span>
          </Forms.FootCell>
        </Forms.Foot>
      </Forms>
    </Field>
  );
}

export default Register;
